import {NavigateFunction} from "react-router-dom";
import {getUserTokenOrRedirect} from "../../../shared/services/auth.service";
import {GearItemDto} from "../dtos/gear.dto";

export async function getAllGear(navigate: NavigateFunction): Promise<GearItemDto[]> {
  const token = await getUserTokenOrRedirect(navigate)
  const response = await fetch(
    `${process.env.REACT_APP_ACCUSITE_API_BASE_URL}/api/v1/gear`,
    {headers: {Authorization: `Bearer ${token}`}});
  if (!response.ok) {
    throw new Error(`Failed to fetch tools and gear: ${response.statusText}`);
  }
  return await response.json() as GearItemDto[];
}
